import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { TotalWeightLossState } from '@common/enums/totalWeightLossState';
import { gewichtInKgSchema } from '@common/validation/schemas';
import { moodSchema, totalWeightLossSchema } from '@common/validation/schemas/caroSchemas';

export type BariPostCaroWeightMeasurementsData = {
    date: Date | string;
    mood: number;
    patientId: string;
    totalWeightLoss: number;
    totalWeightLossState: TotalWeightLossState;
    weight: number;
};

const bariPostCaroWeightMeasurementsFinal: TypedSchema<BariPostCaroWeightMeasurementsData> = {
    date: Koi.string().isoDate(),
    mood: moodSchema,
    patientId: Koi.string().uuid(),
    totalWeightLoss: totalWeightLossSchema,
    totalWeightLossState: Koi.koi().enum(TotalWeightLossState),
    weight: gewichtInKgSchema,
};

export const bariPostCaroWeightMeasurementsDraftSchema = Koi.object(bariPostCaroWeightMeasurementsFinal);
export const bariPostCaroWeightMeasurementsFinalSchema = Koi.object(bariPostCaroWeightMeasurementsFinal);

export type BariPostCaroWeightMeasurementsReadData = BariPostCaroWeightMeasurementsData & {
    totalWeightLossData: {
        totalWeightLoss: BariPostCaroWeightMeasurementsData['totalWeightLoss'];
        totalWeightLossState: BariPostCaroWeightMeasurementsData['totalWeightLossState'];
    };
};

export type BariPostCaroWeightMeasurementsReadKey = keyof BariPostCaroWeightMeasurementsReadData;

export type BariPostCaroWeightMeasurementsLabel = 'Gewicht' | 'Total weight loss';

export const bariPostCaroWeightMeasurementsReadSchema: TypedReadSchema<
    BariPostCaroWeightMeasurementsReadKey,
    BariPostCaroWeightMeasurementsLabel
>[] = [
    {
        items: [
            {
                append: 'kg',
                key: 'weight',
                label: 'Gewicht',
                type: 'number',
            },
            {
                key: 'totalWeightLossData',
                label: 'Total weight loss',
            },
        ],
    },
];
